export default __webpack_public_path__ + "static/media/detail_mobile_13_2.ea00cc0c.jpg";